import React, { Component } from "react";
import CKEditor from "ckeditor4-react";
import * as api from "./../../api/api";

import SimpleReactValidator from "simple-react-validator";

class Comment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      comments: "",
      email_id: "",
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChange = this.onChange.bind(this);

    this.validator = new SimpleReactValidator();
  }

  onChange(e) {
    const { name, value } = e.target;
    console.log(e.target.value);
    this.setState({ [name]: value });
  }

  handleSubmit = async () => {
    //console.log(localStorage.getItem("blogId"));
    const { name, comments, email_id } = this.state;
    try {
      const reqObj = {
        name: name,
        email_id: email_id,
        comments: comments,
        news_id: localStorage.getItem("blogId"),
      };
      console.log("reqObj", reqObj);
      const response = await api.user_comments(reqObj);
      console.log("response", response);
      this.setState({
        success: true,
        fail: false,
        //message: response.data.message,
      });
    } catch (e) {
      this.setState({
        fail: true,
        success: false,
      });
    }
  };

  handleEditor = (e) => {
    this.setState({
      comments: e.editor.getData(),
    });
  };

  render() {
    return (
      <>
        <form className="forms-sample" encType="multipart/form-data">
          <div className="row">
            <div className="form-group col-lg-6">
              <input
                type="text"
                className="form-control"
                id="exampleInputName1"
                placeholder="Name"
                name="name"
                value={this.state.name}
                onChange={this.onChange}
              />
            </div>

            <div className="form-group col-lg-6">
              <input
                type="email"
                className="form-control"
                placeholder="Email"
                name="email_id"
                value={this.state.email_id}
                onChange={this.onChange}
              />
            </div>
          </div>
          <div className="row">
            <div className="form-group col-lg-12">
              <textarea
                className="form-control"
                placeholder="comments..."
                rows="5"
                cols="5"
                name="comments"
                value={this.state.comments}
                onChange={this.onChange}
              ></textarea>
              {/* <CKEditor data="" onChange={this.handleEditor} /> */}
            </div>
          </div>
        </form>
        <button
          onClick={this.handleSubmit}
          disabled={!this.state.name || !this.state.email_id}
          data-dismiss="modal"
          className="btn btn-gradient-primary mr-2"
          style={{ color: "white" }}
        >
          Submit
        </button>
        {/* <button className="btn btn-light">Cancel</button> */}

        {/* {this.state.success ?  */}
        {/* {this.state.success ? (
          <div className="pt-2 text-success">Post added Successfully</div>
        ) : null}

        {this.state.fail ? (
          <div className="pt-2 text-danger">
            Please fill all the required data
          </div>
        ) : null} */}
        {/* <div
                    className={
                      this.state.success
                        ? "pt-2 text-success"
                        : "pt-2 text-danger"
                    }
                  >
                    {this.state.message}
                  </div> */}
        {/* :""}\ */}
      </>
    );
  }
}
export default Comment;
